
import { Box, Button, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, FormGroup, Grid, IconButton, LinearProgress, MenuItem, Typography } from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import { Field, Form, Formik } from 'formik';
import { DatePicker, DateTimePicker } from 'formik-material-ui-pickers';
import React, { useEffect, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import * as Yup from "yup";
import { useAssetTypes } from '../../../testCommunication/common/testQueries';
import { useAssetsView, useAssetUpdate, useLocations } from '../../../intake/intakeQueries';
import { toast } from 'react-toastify';
import { usePostFile } from '../../../common/services/fileServices';
import { useFetchContext } from '../../../common/FetchContext';
import { Select, TextField } from 'formik-material-ui';
import LSDBFormikAutocompleteField from '../../../common/LSDBFormikAutocompleteField';

export const AssetManagementEdit = () => {

  const { asset_id } = useParams() as { asset_id: string };

  const history = useHistory();
  const [openExternalDialog, setOpenExternalDialog] = React.useState(false);
  const [externalFunctionData, setExternalFunctionData] = React.useState<{
    completed: string;
    date: any;
    notes: string;
  } | null>(null);


  // Move hooks to the top level
  const { mutateAsync: mutatePostFile } = usePostFile();
  const { mutateAsync: mutateAsset } = useAssetUpdate();
  const { authAxios } = useFetchContext();
  const { isLoading: isassetLoading,
    isSuccess,
    isError,
    data: assets, } = useAssetsView(asset_id);

  const [checked, setChecked] = React.useState({
    visual_inspection: assets?.usage?.includes('Visual Inspection') || false,
    temperature: assets?.usage?.includes('Temparature') || false,
    angle_measurement: assets?.usage?.includes('Angle Measurement') || false,
    humidity: assets?.usage?.includes('Humidity') || false,
    uv: assets?.usage?.includes('UV') || false,
    insulation_test: assets?.usage?.includes('Insulation Test') || false,

  });

  const [selected, setSelected] = React.useState(false);
  const [isExterneal, setExternel] = React.useState(false);
  const [isPrimaryAsset, setIsPrimaryAsset] = React.useState(false);
  const [files, setFiles] = React.useState([]);
  const fileInputRef = useRef<HTMLInputElement>(null);


  const {
    error: errorAssetTypes,
    data: assetTypes,
    isLoading: isLoadingAssetTypes,
    isError: isErrorAssetTypes,
  } = useAssetTypes();

  const {
    error: errorLocations,
    data: locations,
    isLoading: isLoadingLocations,
    isError: isErrorLocations,
  } = useLocations();

  React.useEffect(() => {
    if (assets) {
      setSelected(assets.is_calibration_required);
      setExternel(assets.external_asset_required);
      setChecked({
        visual_inspection: assets.usage?.includes('Visual Inspection') || false,
        temperature: assets.usage?.includes('Temparature') || false,
        angle_measurement: assets.usage?.includes('Angle Measurement') || false,
        humidity: assets.usage?.includes('Humidity') || false,
        uv: assets.usage?.includes('UV') || false,
        insulation_test: assets.usage?.includes('Insulation Test') || false,
      });
      setIsPrimaryAsset(assets.is_main_asset);
      setExternalFunctionData({
        completed: assets.functionality_check,
        date: assets.date_completed,
        notes: assets.comments,
      });
    }
  }, [assets]);



  if (isassetLoading || isLoadingAssetTypes || isLoadingLocations) {
    return <LinearProgress />

  }






  const handleFileUpload = async (item: any) => {
    console.log(item)
    fileInputRef.current?.click()
  };

  const handleFilePicked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const uploadedFiles = event.target.files;
    if (uploadedFiles) {
      setFiles(uploadedFiles as any);
    }

  };

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked({
      ...checked,
      [event.target.value]: event.target.checked,
    });
  };
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSelected(event.target.checked);
  // };
  // const handleChangeExterneal = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setExternel(event.target.checked);
  // };





  return (
    assets && <>



      <Container maxWidth="sm">
        {console.log(assets)}
        <Grid
          container
          direction="row"
          justify="space-around"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12}>
            <Formik
              enableReinitialize={true}

              initialValues={{

                assetid: assets.asset_number,
                asset_name: assets.asset_name,
                description: assets.description,
                location_id: assets.location,
                manufacturer_name: assets.manufacturer,
                model: assets.model,
                serial_number: assets.serial_number,
                schedule_for_calibration: assets.schedule_for_calibration,
                Days_since_calibrated: assets.days_since_calibrated,
                Days_next_calibration: assets.days_to_next_calibration,
                nextcalibrateddate: assets.next_calibration_date,
                last_action_datetime: assets.last_action_datetime,
                lastcalibrateddate: assets.last_calibrated_date,
                isCalibration: assets.is_calibration_required,
                external_asset_required: assets.external_asset_required,
                asset_type_id: assets.asset_type,
                is_main_asset: assets.is_main_asset,
                external_completed: assets.functionality_check || "",
                external_completed_date: assets.date_completed || null,
                external_notes: assets.comments || "",




              }}
              validationSchema={
                Yup.object({
                  assetid: Yup.string().required("Field must be required"),
                  asset_name: Yup.string().required("Field must be required"),
                  description: Yup.string().required("Field must be required"),
                  location_id: Yup.string().required("Field must be required"),
                  asset_type_id: Yup.string().required("Field must be required"),
                  manufacturer_name: Yup.string().required("Field must be required"),
                  model: Yup.string().required("Field must be required"),
                  serial_number: Yup.string().required("Field must be required"),
                  lastcalibrateddate: Yup.string().nullable().required("Last calibrated date is required "),
                })
              }
              onSubmit={async (values, { setSubmitting }) => {
                // Handle form submission here
                console.log("Form values", JSON.stringify(values));


                try {
                  var usages = "";

                  if (checked.visual_inspection) {

                    usages = "Visual Inspection"

                  }
                  if (checked.angle_measurement) {
                    usages = usages + ", Angle Measurement"

                  }
                  if (checked.humidity) {

                    usages = usages + ", Humidity"

                  }
                  if (checked.uv) {

                    usages = usages + ", UV"

                  }
                  if (checked.temperature) {

                    usages = usages + ", Temperature"

                  }

                  if (checked.insulation_test) {

                    usages = usages + ", Insulation Test"
                  }
                  if (selected) {
                    if (files.length > 0) {
                      for (let file of files) {
                        const postedFile = await mutatePostFile({ authAxios, file });
                        await mutateAsset({
                          authAxios,
                          // id: data.id,
                          id: asset_id,
                          asset_number: values.assetid,
                          asset_name: values.asset_name,
                          description: values.description,
                          last_action_datetime: values.last_action_datetime,
                          location: values.location_id,
                          manufacturer: values.manufacturer_name,
                          model: values.model,
                          serial_number: values.serial_number,
                          next_calibrated_date: values.nextcalibrateddate,
                          last_calibrated_date: values.lastcalibrateddate,
                          schedule_for_calibration: values.schedule_for_calibration,
                          usage: usages,
                          asset_type: values.asset_type_id,
                          is_calibration_required: selected,
                          external_asset_required: isExterneal,
                          azurefile: postedFile.url,
                          is_main_asset: values.is_main_asset,
                          functionality_check: values.external_completed,
                          date_completed: values.external_completed_date,
                          comments: values.external_notes,
                        });
                      }
                    } else {
                      await mutateAsset({
                        authAxios,

                        id: asset_id,
                        asset_number: values.assetid,
                        asset_name: values.asset_name,
                        description: values.description,
                        last_action_datetime: values.last_action_datetime,
                        location: values.location_id,
                        manufacturer: values.manufacturer_name,
                        model: values.model,
                        serial_number: values.serial_number,
                        next_calibrated_date: values.nextcalibrateddate,
                        last_calibrated_date: values.lastcalibrateddate,
                        schedule_for_calibration: values.schedule_for_calibration,
                        usage: usages,
                        is_calibration_required: selected,
                        external_asset_required: isExterneal,
                        asset_type: values.asset_type_id,
                        is_main_asset: values.is_main_asset,
                        functionality_check: values.external_completed,
                        date_completed: values.external_completed_date,
                        comments: values.external_notes,
                      });
                    }

                  } else {
                    await mutateAsset({
                      authAxios,
                      id: asset_id,
                      asset_number: values.assetid,
                      asset_name: values.asset_name,
                      description: values.description,
                      last_action_datetime: values.last_action_datetime,
                      location: values.location_id,
                      manufacturer: values.manufacturer_name,
                      model: values.model,
                      serial_number: values.serial_number,
                      usage: usages,
                      is_calibration_required: selected,
                      external_asset_required: isExterneal,
                      asset_type: values.asset_type_id,
                      is_main_asset: values.is_main_asset,
                    })
                  }


                  toast.success("Asset successfully updated")
                  setSubmitting(false);

                  history.goBack();



                } catch (e) {
                  toast.error(`Error updating: ${e}`);
                }
              }}
            >
              {({ errors, touched, submitForm, resetForm, setFieldValue, validateForm, values }) => {
                React.useEffect(() => {
                  setFieldValue('isCalibration', selected);
                  setFieldValue('external_asset_required', isExterneal);
                  setFieldValue('is_main_asset', isPrimaryAsset);
                }, [selected, isExterneal, isPrimaryAsset, setFieldValue]);

                const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                  const isChecked = event.target.checked;
                  setSelected(isChecked);
                  if (!isChecked) {
                    setExternel(false);
                  }
                };

                const handleChangeExterneal = (event: React.ChangeEvent<HTMLInputElement>) => {
                  setExternel(event.target.checked);
                  setFieldValue('external_asset_required', event.target.checked)
                  const checked = event.target.checked;
                  if (checked) {
                    setOpenExternalDialog(true);
                  } else {
                    setExternalFunctionData(null);
                  }
                };
                const handleMainAssetChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                  setIsPrimaryAsset(event.target.checked);
                  setFieldValue('is_main_asset', event.target.checked)

                };
                return (
                  <>
                    <Form>
                      <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="center"
                        spacing={4}
                      >
                        <Grid item xs={6}>
                          <Field
                            id="assetid"
                            type="text"
                            name="assetid"
                            fullWidth
                            component={TextField}
                            style={{ marginBottom: 20 }}
                            label="Asset Number"
                          />

                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="is_main_asset"
                                color="primary"
                                checked={isPrimaryAsset}
                                onChange={handleMainAssetChange}
                              />
                            }
                            label="Is Primary Asset"
                          />

                        </Grid>

                        <Grid item xs={6}>
                          <Field
                            id="asset_name"
                            type="text"
                            name="asset_name"

                            fullWidth
                            component={TextField}
                            style={{ marginBottom: 20 }}
                            label="Asset Name"

                          />
                        </Grid>
                        <Grid item xs={6}>
                          {/* <Field
                        id="description"
                        type="text"
                        name="description"
                        fullWidth
                        component={TextField}
                        style={{ marginBottom: 20 }}
                        label="description"

                      /> */}
                          <Field
                            id="description"
                            name="description"
                            component={TextField}

                            style={{ marginBottom: 20 }}
                            label="description"
                            inputVariant="outlined"
                            fullWidth

                          />
                        </Grid>
                        <Grid item xs={6}>

                          <Field
                            id="last_action_datetime"
                            name="last_action_datetime"
                            component={DateTimePicker}
                            format="YYYY-MM-DD"
                            style={{ marginBottom: 20 }}
                            label="Last action date-time"
                            inputVariant="outlined"
                            fullWidth

                          />
                        </Grid>
                        <Grid item xs={6}>
                          {/* <Field
                          id="asset_type_id"
                          type="text"
                          name="asset_type_id"
                          fullWidth
                          component={Select}
                          style={{ marginBottom: 20 }}
                          label="Asset Type"


                        >
                          {assetTypes?.map((location: any) => (
                            <MenuItem
                              key={location.id}
                              value={location.url}
                            >
                              {location.name}
                            </MenuItem>
                          ))}
                        </Field> */}
                          <LSDBFormikAutocompleteField
                            fieldId="asset_type_id"
                            fieldName="asset_type_id"
                            fieldDisplayName="Asset Type"
                            options={assetTypes}
                            getOptionLabel={(assetType: any) => assetType.name}
                            getOptionValue={(assetType: any) => assetType.url}
                            fullWidth={true}
                            variant="standard"
                          />
                        </Grid>
                      </Grid>
                      <div>
                        <Box paddingTop={4} paddingBottom={1}>
                          <Typography variant="subtitle1" color="secondary">
                            Usage
                          </Typography>
                        </Box>

                      </div>
                      <FormGroup>

                        <FormControlLabel
                          control={<Checkbox value="visual_inspection" color="primary" onChange={handleCheckBoxChange} checked={checked.visual_inspection} />}
                          label="Visual Inspection"
                        />

                        <br />

                        <FormControlLabel
                          control={<Checkbox value="temperature" color="primary" onChange={handleCheckBoxChange} checked={checked.temperature} />}
                          label="Temperature"
                        />

                        <br />

                        <FormControlLabel
                          control={<Checkbox value="insulation_test" color="primary" onChange={handleCheckBoxChange} checked={checked.insulation_test} />}
                          label="Insulation Test"
                        />

                        <br />


                        <FormControlLabel
                          control={<Checkbox value="angle_measurement" color="primary" onChange={handleCheckBoxChange} checked={checked.angle_measurement} />}
                          label="Incident Angle Measurement"
                        />

                        <br />

                        <FormControlLabel
                          control={<Checkbox value="humidity" color="primary" onChange={handleCheckBoxChange} checked={checked.humidity} />}
                          label="Humidity"
                        />

                        <br />

                        <FormControlLabel
                          control={<Checkbox value="uv" color="primary" onChange={handleCheckBoxChange} checked={checked.uv} />}
                          label="UV"
                        />

                        <br />

                      </FormGroup>
                      <Grid
                        container
                        direction="row"
                        justify="space-between"
                        style={{ marginBottom: 18 }}
                        alignItems="center"
                        spacing={4}
                      >

                        <Grid item xs={6}>
                          {/* <Field
                          id="location_id"
                          type="text"
                          name="location_id"
                          fullWidth
                          component={Select}
                          style={{ marginBottom: 20 }}
                          label="Location"

                        >
                          {locations?.map((location: any) => (
                            <MenuItem
                              key={location.id}
                              value={location.url}
                            >
                              {location.name}
                            </MenuItem>
                          ))}
                        </Field> */}
                          <LSDBFormikAutocompleteField
                            fieldId="location_id"
                            fieldName="location_id"
                            fieldDisplayName="Location"
                            options={locations}
                            getOptionLabel={(location: any) => location.name}
                            getOptionValue={(location: any) => location.url}
                            fullWidth={true}
                            variant="standard"
                          />
                        </Grid>


                        <Grid item xs={6}>
                          <Field
                            id="manufacturer_name"
                            type="text"
                            name="manufacturer_name"
                            fullWidth
                            component={TextField}
                            style={{ marginBottom: 20 }}

                            label="Manufacturer name"
                          >
                          </Field>
                        </Grid>

                        <Grid item xs={6}>
                          <Field
                            id="model"
                            type="text"
                            name="model"
                            fullWidth
                            component={TextField}

                            label="Model"
                          >
                          </Field>
                        </Grid>


                        <Grid item xs={6}>
                          <Field
                            id="serial_number"
                            type="text"
                            name="serial_number"
                            fullWidth
                            component={TextField}

                            label="Serial Number"
                          >
                          </Field>
                        </Grid>

                      </Grid>
                      <div>
                        <Box paddingTop={2} paddingBottom={1}>
                          <Typography variant="subtitle1" color="secondary">
                            Calibration Details
                          </Typography>
                        </Box>

                      </div>

                      {/* <FormControlLabel
                    control={<Checkbox value="isCalibration" color="primary" onChange={handleChange} />}
                    label="Is calibration required or not?"
                  /> */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="isCalibration"
                            color="primary"
                            checked={selected}
                            onChange={handleChange}
                          />
                        }
                        label="Is calibration required or not?"
                      />
                      {selected && (
                        <Grid
                          container
                          direction="row"
                          justify="space-between"
                          alignItems="center"
                          spacing={4}
                        >
                          <Grid item xs={6}>
                            {/* <FormControlLabel
                        control={<Checkbox value="isExnel" color="primary" onChange={handleChangeExterneal} />}
                        label="External Calibration"
                      /> */}
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="external_asset_required"
                                  color="primary"
                                  checked={isExterneal}
                                  onChange={handleChangeExterneal}
                                />
                              }
                              label="External Calibration"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            {isExterneal && externalFunctionData && (
                              <Box display="flex" justifyContent="space-between">
                                <Box>
                                  <Typography variant="subtitle2">
                                    Functionality Check: {externalFunctionData.completed}
                                  </Typography>

                                  <Typography variant="subtitle2">
                                    Date: {externalFunctionData.date ? new Date(externalFunctionData.date).toLocaleDateString() : ""}
                                  </Typography>

                                  <Typography variant="subtitle2">
                                    Comments: {externalFunctionData.notes}
                                  </Typography>
                                </Box>

                                <IconButton
                                  onClick={() => {
                                    setOpenExternalDialog(true);
                                    setFieldValue("external_completed", externalFunctionData.completed);
                                    setFieldValue("external_completed_date", externalFunctionData.date);
                                    setFieldValue("external_notes", externalFunctionData.notes);
                                  }}
                                >
                                  <Edit fontSize="small" color="primary" />
                                </IconButton>
                              </Box>
                            )}
                          </Grid>

                          <Grid item xs={6}>
                            <Field
                              id="lastcalibrateddate"
                              name="lastcalibrateddate"
                              component={DateTimePicker}
                              format="YYYY-MM-DD"
                              style={{ marginBottom: 20 }}
                              label="Last calibrated date"
                              inputVariant="outlined"
                              fullWidth

                            />
                          </Grid>


                          <Grid item xs={6}>

                            <Field
                              id="schedule_for_calibration"
                              name="schedule_for_calibration"
                              component={TextField}
                              fullWidth
                              style={{ marginBottom: 32, marginRight: 32 }}
                              label="Schedule for the calibration"

                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Field
                              id="nextcalibrateddate"
                              name="nextcalibrateddate"
                              component={DatePicker}
                              format="YYYY-MM-DD"
                              style={{ marginBottom: 32, marginRight: 32 }}
                              label="next calibrated date"
                              inputVariant="outlined"
                              disabled
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Field
                              style={{ marginBottom: 32, marginLeft: 10 }}
                              id="Days_since_calibrated"
                              name="Days_since_calibrated"
                              component={TextField}
                              label="Days since calibrated"
                              inputVariant="standard"
                              disabled

                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Field
                              style={{ marginBottom: 32 }}
                              id="Days_next_calibration"
                              name="Days_next_calibration"
                              component={TextField}
                              label="Days to next calibration"
                              inputVariant="standard"
                              disabled

                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Typography variant="h5" color="primary" >Upload Calibration Report  <img onClick={handleFileUpload} src="/file_upload.svg" alt="Custom Icon" width="30" height="30" /></Typography>
                          </Grid>
                          <Grid item xs={4}>

                            <input
                              ref={fileInputRef}
                              type="file"
                              style={{ display: 'none' }}
                              // accept="image/*,.pdf"
                              onChange={handleFilePicked}
                            />
                            {files.length != 0 && <div style={{ position: "relative", display: "inline-block" }}>
                              <img src="/file_icon.png" alt="Custom Icon" height={200} width={200} />
                              <IconButton
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                  background: "lightgray",
                                  color: "black",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "40px",
                                  height: "40px",
                                }}
                                onClick={() => setFiles([])}
                              >
                                <Delete></Delete></IconButton>
                            </div>}
                          </Grid>
                        </Grid>
                      )}
                      <Grid
                        container
                        spacing={3}
                        direction="row"
                        justify="space-around"
                        alignItems="center"
                        style={{ marginTop: 32 }}
                      >
                        <Grid item xs={4}>


                          <Button
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                              const errors = await validateForm();
                              if (Object.keys(errors).length > 0) {
                                const firstError = Object.values(errors)[0] as string;
                                toast.error(firstError);
                              } else {
                                submitForm();
                              }
                            }}
                          >
                            UPDATE
                          </Button>


                        </Grid>
                      </Grid>

                    </Form>
                    <Dialog open={openExternalDialog} onClose={() => setOpenExternalDialog(false)}>
                      <DialogTitle>External Calibration</DialogTitle>

                      <DialogContent>
                        <Grid container spacing={2}>

                          <Grid item xs={12}>
                            <Field
                              name="external_completed"
                              component={TextField}
                              select
                              label="Functionality Check Completed?"
                              fullWidth
                              SelectProps={{ native: true }}
                            >
                              <option value="" />
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </Field>
                          </Grid>

                          <Grid item xs={12}>
                            <Field
                              name="external_completed_date"
                              component={DatePicker}
                              format="YYYY-MM-DD"
                              label="Date Completed"
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Field
                              name="external_notes"
                              component={TextField}
                              label="Comments"
                              multiline
                              rows={3}
                              fullWidth
                            />
                          </Grid>

                        </Grid>
                      </DialogContent>

                      <DialogActions>
                        <Button onClick={() => {
                          // 1. Close dialog
                          setOpenExternalDialog(false);


                          setExternel(false);


                          setFieldValue("external_completed", "");
                          setFieldValue("external_completed_date", "");
                          setFieldValue("external_notes", "");
                        }}>Cancel</Button>

                        <Button
                          onClick={() => {
                            setExternalFunctionData({
                              completed: values.external_completed,
                              date: values.external_completed_date,
                              notes: values.external_notes,
                            });
                            setOpenExternalDialog(false);
                          }}
                          color="primary"
                        >
                          Save
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </>
                )
              }}
            </Formik>
          </Grid>
        </Grid>
      </Container >
    </>

  )
}

